export default __webpack_public_path__ + "static/media/mob9.9e6fe2e9.svg";